
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.083 4.631l.431 9.428h-.848l.216-9.428a.462.462 0 00.201 0zm-.431-.127s-.226.113-1.074.679c-.848.565-.848 1.413-.848 1.413s.792-.057 1.357-.961c.452-.848.565-1.131.565-1.131zm.791-.282s.283-.057 1.3-.113c1.018-.057 1.527.565 1.527.565s-.679.452-1.64.056c-.96-.395-1.187-.508-1.187-.508zm-.476-.558a.459.459 0 110 .918.459.459 0 010-.918zm-.145-.007s-.113-.283-.735-1.074C5.465 1.791 5.748 1 5.748 1s.735.339.904 1.357c.17 1.017.17 1.3.17 1.3z"}})])
          )
        }
      }
    